import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterUsersService } from 'app/organization/core/services/filter-users.service';
import { WorkingTimeSchemaService } from '../working-time-schema.service';

@Component({
    selector: 'working-time-schema-filters',
    templateUrl: 'working-time-schema-filters.component.html',
    styleUrls: ['working-time-schema-filters.component.scss']
})

export class WorkingTimeSchemaFiltersComponent {
    public selectedFilterColumnsResources: string = 'FullName';
    public propertyDisplay: string = 'fullName';
    public selectedUser: ISpecificUser;
    public filteredUsers = [];
    public baseCalendars = [];
    public dateCustomClasses = [];
    
    public filterColumnsResources = {
        ContactEmail: 'USER_GROUPS.CONTACT_EMAIL',
        FullName: 'USER_GROUPS.FULLNAME',
        UserName: 'USER_GROUPS.USERNAME'
    };

    @Input() idBaseCalendarSelected = 1;

    @Output() emitSelectedCalendar = new EventEmitter();
    @Output() emitUserSelected = new EventEmitter();

    constructor(private _filterUsersService: FilterUsersService, private _workingTimeSchemaService: WorkingTimeSchemaService
    ) {
        this.getCalendarOptions();
    }

    getCalendarOptions() {
        this._workingTimeSchemaService.getCalendarOptions().subscribe(calendars => {
            this.baseCalendars = calendars;
        });
    }

    getUserFilter(value) {
        if (this.selectedFilterColumnsResources && value)
        {
            this._filterUsersService.filterUsers(this.selectedFilterColumnsResources, value).subscribe(users => {
                this.filteredUsers = [];
                
                if (this.selectedFilterColumnsResources === 'FullName') {
                    this.propertyDisplay = 'fullName';
                } else if (this.selectedFilterColumnsResources === 'ContactEmail') {
                    this.propertyDisplay = 'contactEmail';
                } else
                    this.propertyDisplay = 'userName';

                    this.filteredUsers = users.map(user => {
                        return {
                            ...user,
                            propertyDisplay: this.propertyDisplay
                        };
                    });
            });
        } else if (!value) {
            this.selectedUser = null;
            this.filteredUsers = [];
            this.emitUserSelected.emit(this.selectedUser);
        }
    }

    userSelected(userSeleted) {
        this.selectedUser = userSeleted;
        this.emitUserSelected.emit(userSeleted);
    }

    displayFn(user?: ISpecificUser): string | undefined {
        if (user.propertyDisplay === 'fullName')
            return user.fullName;
        else if (user.propertyDisplay === 'contactEmail')
            return user.contactEmail;
        else
            return user.userName;
    }

    onBaseCalendarChanged(calendar) {
        this.idBaseCalendarSelected = calendar.idWorkingTimeSchema;
        this.emitSelectedCalendar.emit(calendar);
    }

    changeFilterColumn(selectedFilterColumnsResources) {
        this.selectedFilterColumnsResources = selectedFilterColumnsResources;
        this.selectedUser = null;
        this.filteredUsers = [];
        this.emitUserSelected.emit(this.selectedUser);

        let elementosPadre = document.querySelectorAll('#userAutocomplete')[0];
        if (elementosPadre && elementosPadre.children.length > 1 && elementosPadre.children[1].children.length > 1) {
            let inputValue = elementosPadre.children[1].children[1] as HTMLInputElement;
            inputValue.value = '';
        }
    }
}